import type { ComponentType } from 'react';

import STYLES from './StackingContextReset.module.scss';

import displayName from '@shared/utils-frontend/display-name';

const withStackingContextReset = <P extends object>(
  WrappedComponent: ComponentType<P>,
) => {
  const component = (props: P) => (
    <div className={STYLES.StackingContextReset}>
      <WrappedComponent {...props} />
    </div>
  );

  component.displayName = displayName(WrappedComponent);

  return component;
};

export default withStackingContextReset;
